import { render, staticRenderFns } from "./FormFeature.vue?vue&type=template&id=1c9ff9e8&scoped=true"
import script from "./FormFeature.vue?vue&type=script&lang=js"
export * from "./FormFeature.vue?vue&type=script&lang=js"
import style0 from "./FormFeature.vue?vue&type=style&index=0&id=1c9ff9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ff9e8",
  null
  
)

export default component.exports